import React, { createContext, useState, useEffect } from "react";
import axiosInstance from "../api/axios"; // make sure this has baseURL and token handling

const AuthContext = createContext({ token: null, user: null });

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("authToken"));
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        try {
          const res = await axiosInstance.get("/auth/user/", {
            headers: {
              Authorization: `Token ${token}`,
            },
          });
          setUser(res.data); // sets username, email, etc
        } catch (err) {
          console.error("Error fetching user:", err);
          setUser(null);
        }
      }
    };

    fetchUser();
  }, [token]);

  // const login = async (token) => {
  //   setToken(token);
  //   localStorage.setItem("authToken", token);
  // };

  const login = async (email, password) => {
    try {
      const res = await axiosInstance.post(
        "/auth/login/",
        { username: email, password: password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setToken(res.data.key);
      localStorage.setItem("authToken", res.data.key);
    } catch (err) {
      console.error("Failed to Login!!", err);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("authToken");
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
